import 'es6-promise/auto';
import * as React from 'react';
import * as _ from 'lodash';
import { PerformanceViewModel, ReserveRequest, GroupedPerformanceModel, defaultPerformanceModel, IProductionModels} from './classes'
import PerformanceAddOnsProductionDisplay from './performance-addons-display-production'

import { performance } from 'perf_hooks';

interface PerformanceAddOnsDisplayProps {
    productions: Array<PerformanceViewModel>
}

interface PerformanceAddOnsDisplayState {
    productions: Array<PerformanceViewModel>
    groupedProductions: Array<GroupedPerformanceModel>;
}

class PerformanceAddOnsDisplay extends React.Component<PerformanceAddOnsDisplayProps, PerformanceAddOnsDisplayState>{
    constructor(props) {
        super(props)
        this.state = {
            productions: this.props.productions as Array<PerformanceViewModel>,
            groupedProductions: this.setGroupedProductions(this.props.productions)
        }
    }


    componentWillReceiveProps(props) {
        const { productions } = this.props;
        if (props.productions !== productions) {
            this.setState({
                productions: this.filterProductionList(props.productions),
                groupedProductions: this.setGroupedProductions(props.productions)
            })
        }
    }

    setGroupedProductions(productionList: Array<PerformanceViewModel>): Array<any> {
        var groupedProductions = [];
        var grouped = _.groupBy(productionList, production => production.productionId);
        console.log(grouped);
        for (let prod in grouped) {
            var groupedProduction: GroupedPerformanceModel = { productionID: Number(prod), performanceModels: grouped[prod] }
            groupedProductions.push(groupedProduction);
        }
        var sortedGroupedProductions = this.sortProductions(groupedProductions);
        return sortedGroupedProductions;
    }

    sortProductions(groupedProductions: Array<any>): Array<any> {
        var productionModel = (JSON.parse(JSON.stringify((window as any).bootStrappedData)) as IProductionModels);
        let result = []
        productionModel.performanceModels.forEach(function(key) {
            var found = false;
            groupedProductions = groupedProductions.filter(function (item) {
                if (!found && (item as GroupedPerformanceModel).productionID == key.productionId) {
                    result.push(item);
                    found = true;
                    return false;
                } else
                    return true;
            })
        })
        return result;
    }

    filterProductionDisplay(groupedProductions: Array<GroupedPerformanceModel>, productionId: number): Array<PerformanceViewModel> {
        for (let i = 0; i < groupedProductions.length; i++) {
            if (groupedProductions[i].productionID == productionId)
                return groupedProductions[i].performanceModels;
        }
        return [];
    }

    filterProductionList(productions: Array<PerformanceViewModel>): any {
        let productionID = new Array();
        let newProductions = new Array();

        for (var i = 0, len = productions.length; i < len; i++) {
            if (productionID.indexOf(productions[i].productionId) === -1) {
                productionID.push(productions[i].productionId)
                newProductions.push(productions[i]);
            }
        }

        var productionModel = (JSON.parse(JSON.stringify((window as any).bootStrappedData)) as IProductionModels);
        let result = []
        productionModel.performanceModels.forEach(function (key) {
            var found = false;
            newProductions = newProductions.filter(function (item) {
                if (!found && (item as PerformanceViewModel).productionId == key.productionId) {
                    result.push(item);
                    found = true;
                    return false;
                } else
                    return true;
            })
        })

        console.log(result);
        return result;

       
    }

   

    render() {
        return (
            <dl role="presentation" className="adage-accordion-inner addons-performance-list" data-accordion-list="0">
                {
                    this.state.productions.map((value) => {
                        return (
                            <div key={value.productionId}>
                                <PerformanceAddOnsProductionDisplay production={value} groupedProductions={this.filterProductionDisplay(this.state.groupedProductions, value.productionId)} />      
                            </div>
                        )
                    })
                }
            </dl>
        );
    }
}

export default PerformanceAddOnsDisplay;